import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ApprovalFlowStep  {
    _originalTypeClassName = "zERP.BO.ApprovalFlowStep";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ApprovalFlowStep.translate = translateService;
}
this.Scenario = new Domain.ApprovalFlowScenario();
this.Id = null;
this.Index = null;
this.Action = null;
this.Role = null;
this.ActorType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Index:any;
Action:any;
Role:any;
ActorType:any;
User:any;
Department:any;
Scenario:any;
static setUser = ($this, value) => {
var oldValue = $this.User;
$this.User = value;
if (value != null) {
}
}
static setDepartment = ($this, value) => {
var oldValue = $this.Department;
$this.Department = value;
if (value != null) {
}
}
static setScenario = ($this, value) => {
var oldValue = $this.Scenario;
$this.Scenario = value;
if (value != null) {
if (oldValue != null) {
Domain.ApprovalFlowScenario.removeSteps(oldValue, $this);
}
Domain.ApprovalFlowScenario.addSteps(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}